import { PageLayout } from '../../PageLayout';
import { McpAccessSection } from '../../Compounds/McpAccess/McpAccessSection';

export const SettingsPage = () => {
  return (
    <PageLayout
      dataTestId="settings-page"
      pageTitle="Settings">
      <McpAccessSection />
    </PageLayout>
  );
};
